<template>
  <fbf-vue-cookie-modal ref="cookieModal" .lang="shortLocale" />
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import config from '@/config';
import useGTM from '@/services/useGTM';

const { locale } = useI18n();
const { consent } = useGTM();

const cookieModal = ref(null);

const shortLocale = computed(() => locale.value.split('-')[0]);
const hideCookies = ref();

onMounted(async () => {
  if (!window.CookieModal) return;

  const { consts } = window.CookieModal;

  if (!(await config()).analytics?.gtmId) {
    hideCookies.value = [consts.COOKIE_MODAL_GROUPS_DEFAULT.performance];
    return;
  }

  cookieModal.value?.addEventListener(consts.COOKIE_MODAL_EVENTS.close, (event) => {
    const eventDetail = (event as Event & { detail: Record<string, boolean>[] }).detail[0];

    const cookieGroupActions = {
      performance: (value: boolean) => {
        consent('update', value);
      },
    };

    Object.keys(eventDetail).forEach((key) => cookieGroupActions?.[key]?.(eventDetail[key]));
  });
});
</script>
